import "./Header.css";
import CanvasLogo from "../canvas-logo/CanvasLogo";

export default function Header() {
  return (
    <header className="app-header">
      <CanvasLogo />
      <div className="app-header__title">
        <h1>Daniel St. Germain</h1>
        <span>Engineering Lead & Senior Frontend Software Engineer</span>
      </div>
    </header>
  );
}
